// extracted by mini-css-extract-plugin
export var container = "_3q-1";
export var editor = "_3q-2";
export var resizable = "_3q-3";
export var wrapper = "_3q-0";